var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarimg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.464,
    height: 27.645,
    viewBox: "0 0 33.464 27.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "news-svgrepo-com",
    d: "M5.513,31.6q-.864,0-1.727-.034l-.269-.061a3.694,3.694,0,0,1-2.789-2.9l-.044-.225C.672,28.125.66,27.391.66,26.753V5.121A1.167,1.167,0,0,1,1.824,3.959H27.838A1.164,1.164,0,0,1,29,5.121v3.74h3.892a1.238,1.238,0,0,1,1.233,1.233V27.687A3.914,3.914,0,0,1,30.21,31.6Zm0-2.713H26.482a3.909,3.909,0,0,1-.188-1.2V22.372q-.007-.133-.007-.267V6.669H3.373V26.753c0,.533.007,1.052.015,1.331l0,.02a.981.981,0,0,0,.734.763l.024,0C4.476,28.881,5.027,28.891,5.513,28.891ZM23.288,10.945H6.262v2.713H23.288ZM13.5,16.775H6.262v8.64H13.5Zm9.79.064H16.25v2.713h7.04Zm0,5.9H16.25v2.71h7.04Zm5.714-11.162V27.69a1.2,1.2,0,0,0,2.407,0V11.569Z",
    transform: "translate(-0.66 -3.959)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarimg2);
export default __webpack_public_path__ + "static/media/sidebarimg2.505d8f1dbf761be0fb9dcb3fe14a2f08.svg";
export { ForwardRef as ReactComponent };